/**
 * A short burst of confetti over the whole screen, for the moments that
 * deserve one: the first funds, a trade settling, rewards arriving. A canvas
 * for a second and a half, then gone. Nothing when the person asked for less
 * motion.
 */
export function celebrate(): void {
  if (typeof document === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const canvas = document.createElement('canvas');
  canvas.className = 'confetti';
  canvas.setAttribute('aria-hidden', 'true');
  const ctx = canvas.getContext('2d');
  if (ctx === null) return;
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  const w = window.innerWidth;
  const h = window.innerHeight;
  canvas.width = w * dpr;
  canvas.height = h * dpr;
  ctx.scale(dpr, dpr);
  document.body.appendChild(canvas);
  const colors = ['#2e9e5b', '#2481cc', '#f5b400', '#e9663b', '#8b5cf6'];
  const pieces = Array.from({ length: 90 }, (_, i) => ({
    x: w / 2 + (Math.random() - 0.5) * 80,
    y: h * 0.45,
    vx: (Math.random() - 0.5) * 14,
    vy: -6 - Math.random() * 9,
    r: 4 + Math.random() * 4,
    a: Math.random() * Math.PI,
    va: (Math.random() - 0.5) * 0.3,
    c: colors[i % colors.length] ?? '#2481cc',
  }));
  const start = performance.now();
  const frame = (t: number): void => {
    const dt = (t - start) / 1000;
    ctx.clearRect(0, 0, w, h);
    for (const p of pieces) {
      p.vy += 0.35;
      p.x += p.vx;
      p.y += p.vy;
      p.vx *= 0.985;
      p.a += p.va;
      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.a);
      ctx.globalAlpha = Math.max(0, 1 - dt / 1.5);
      ctx.fillStyle = p.c;
      ctx.fillRect(-p.r / 2, -p.r / 2, p.r, p.r * 1.6);
      ctx.restore();
    }
    if (dt < 1.6) requestAnimationFrame(frame);
    else canvas.remove();
  };
  requestAnimationFrame(frame);
}
